import { ChatsPage } from 'components/chats/ChatsPage'

export const ProfileChats: React.FC = () => {
  return <ChatsPage />
}

